<template>
  <div>
    <div v-if="data.displayDetail" class="iconsconfig-list flex actions-bar">
      <informative-preview-data v-if="canDisplayPreview" :data="data" :isDesktop="isDesktop" :isAuthenticated="isAuthenticated"
        :isItemNews="isItemNews" :iconReferencePreview="iconReferencePreview" @open-detail="$emit('openDetail', data)"></informative-preview-data>

      <vx-tooltip :text="$t('MULTIMEDIA').Add_Playlist" position="top" delay=".1s" v-if="canAddPlaylist && canDisplayAddPlaylist">
        <feather-icon icon="PlaylistIcon" svgClasses="icon-safra"  @click.stop="$emit('addPlaylist', data)" />
      </vx-tooltip>
      <vx-tooltip :text="$t('MULTIMEDIA').Play" position="top" delay=".1s" v-if="hasMultimedia && canDisplayMultimedia">
        <feather-icon :icon="getIconCard" @click.stop="$emit('playMultimedia', { data: data, isTextSpeech: false })"/>
      </vx-tooltip>
      <vx-tooltip :text="$t('ACCESSIBILITY').To_Hear" position="top" delay=".1s" v-if="canSpeechText && canDisplaySpeechText">
        <feather-icon icon="Volume2Icon" @click.stop="$emit('playMultimedia', { data: data, isTextSpeech: true })" />
      </vx-tooltip>
      <vx-tooltip text="Download" position="top" delay=".1s" v-if="hasDocument && canDisplayDownloadFile">
        <feather-icon icon="PaperclipIcon" @click.stop="$emit('onDownloadFile', data)" />
      </vx-tooltip>
      <vx-tooltip :text="$t('BUTTONS').Save" position="top" v-show="canDisplaySave && canSaveScheduleItem">
        <feather-icon icon="SaveIcon" @click.stop="$emit('save-schedule-news', data)" />
      </vx-tooltip>
      <vx-tooltip :text="$t('BUTTONS').Remove" position="top" delay=".1s" v-if="canDisplayRemove">
        <feather-icon icon="TrashIcon" @click.stop="$emit('remove-news', data)" />
      </vx-tooltip>
      
    </div>
    <div class="flex icons-details items-center iconsconfig-list" v-if="!data.displayDetail" @open-detail="$emit('openDetail', data)">
      <vx-tooltip text="Conteúdo exclusivo" position="top" delay=".1s"><span  class="iconsafra"><feather-icon icon="LockIcon" class="mr-0" :svgClasses="['icon-Volume']"/></span></vx-tooltip>
      <!-- <vx-tooltip text="Conteúdo exclusivo" position="top" delay=".1s"><span  class="iconsafra"><feather-icon @click.stop="$emit('open-exclusive-content')" icon="LockIcon" class="mr-0" :svgClasses="['icon-Volume']"/></span></vx-tooltip> -->
    </div>
  </div>
</template>

<script>
import generalHelper from '../../../helpers/general-helper';
import InformativePreviewData from '../../../views/pages/informative/InformativePreviewData.vue';

export default {
  components: { InformativePreviewData },
  props: {
    data: {
        type: Object,
        require: true
    },
    isAuthenticated: {
      type: Boolean,
      require: true
    },
    isDesktop: {
      type: Boolean,
      require: true
    },
    isItemNews: {
      type: Boolean,
      require: true
    },
    canDisplayPreview: {
      type: Boolean,
      require: true,
      default: false
    },
    canDisplayAddPlaylist: {
      type: Boolean,
      default: true
    },
    canDisplayMultimedia: {
      type: Boolean,
      default: true
    },
    canDisplaySpeechText: {
      type: Boolean,
      default: true
    },
    canDisplayDownloadFile: {
      type: Boolean,
      default: true
    },
    canDisplayDownloadFile: {
      type: Boolean,
      default: true
    },
    canDisplaySave: {
      type: Boolean,
      default: true
    },
    iconReferencePreview: {
      type: Boolean,
      default: true
    },
    canDisplayRemove: {
      type: Boolean,
      default: false
    }
  },
  created() {
  },
  computed: {
    scheduleData() {
      return this.$store.state.scheduleData || [];
    },
    canSaveScheduleItem() {
    setTimeout(() => {
      
    }, 500);
    const currentDate = new Date();
    const dateTo = new Date(this.data.eventScheduleDuration_dateTo);

    return this.data.type === 'calendar' &&
      (this.data.disclosureType === 1 || this.data.disclosureType === 2) &&
      this.scheduleData.findIndex(item => item._id === this.data._id) < 0 &&
      dateTo >= currentDate;
    },
    hasMultimedia() {
      return (this.hasAudio || this.hasYoutube || this.hasSoundCloud || this.hasSpotify);
    },
    getIconCard() {
      if (this.hasYoutube) {
        return "VideoIcon";
      } else if (
        this.hasAudio ||
        this.hasSoundCloud ||
        this.hasSpotify
      ) {
        return "MicIcon";
      } else if (this.hasDocument) {
        return "PaperclipIcon";
      } else {
        return null;
      }
    },
    canAddPlaylist() {
      return (
        this.hasYoutube ||
        this.hasAudio ||
        this.hasSpotify ||
        this.hasSoundCloud
      ) && this.isAuthenticated;
    },
    hasDocument() {
      return !!this.data.document;
    },
    hasAudio() {
      return !!this.data.audio;
    },
    hasYoutube() {
      return !!this.data.youtubeId;
    },
    hasSpotify() {
      return !!this.data.spotify;
    },
    hasSoundCloud() {
      return !!this.data.soundcloud;
    },
    hasImageUrl() {
      return !!this.data.image;
    },
    canSpeechText() {
      return generalHelper.canSpeechText(this.data, this.isDesktop);
    },
  }
};
</script>

<style>
</style>